const l = {
  name: "OptIn",
  dimensions: { width: 36, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 35.7 40" style="enable-background:new 0 0 35.7 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M21.1,5.9l-2.3,2.3V0h-2v8.2l-2.3-2.2l-1.4,1.4l4.7,4.7l4.7-4.7L21.1,5.9z"/>
		<path class="st0" d="M22.5,32.7L17.8,28l-4.7,4.7l1.4,1.4l2.3-2.3V40h2v-8.1l2.3,2.2L22.5,32.7z"/>
		<path class="st0" d="M4,24.2l3.1,0.8L0,29.2l1,1.7l7.1-4.1l-0.8,3.1l1.9,0.5l1.7-6.4l-6.4-1.7L4,24.2z"/>
		<path class="st0" d="M28.4,10.1l-0.8,3.1l7.1-4.1l1,1.7l-7.1,4.1l3.1,0.8l-0.5,1.9L24.8,16l1.7-6.4L28.4,10.1z"/>
		<path class="st0" d="M31.7,24.2L28.6,25l7.1,4.1l-1,1.7l-7.1-4.1l0.8,3.1l-1.9,0.5L24.8,24l6.4-1.7L31.7,24.2z"/>
		<path class="st0" d="M7.3,10.1l0.8,3.1L1,9.2l-1,1.7L7.1,15L4,15.8l0.5,1.9l6.4-1.7L9.2,9.6L7.3,10.1z"/>
		<path class="st0" d="M17.9,14c-3.3,0-6,2.7-6,6s2.7,6,6,6s6-2.7,6-6S21.2,14,17.9,14z M13.9,20c0-2.2,1.8-4,4-4s4,1.8,4,4
			s-1.8,4-4,4S13.9,22.2,13.9,20z"/>
	</g>
</g>
</svg>
  `
};
export {
  l as OptIn
};
